// extracted by mini-css-extract-plugin
module.exports = {"timeline":"styles_timeline__o8HMV","items":"styles_items__2Qvg_","date":"styles_date__13c6C","item":"styles_item__gbQ6-","href":"styles_href__1jjR-"};